export default {
    geofence_radius_sim: 10000,
    geofence_radius_gps: 5000
}
   
